import { AnalyticsUtils } from '@analytics/utils';
import { Injectable } from '@angular/core';
import { JssPlatformService } from '@core/jss-platform';
import type {
  HeatpumpsFunnelSettingsInterface,
  HeatpumpsFunnelStep,
} from '@innogy/feh/models';
import type { GenericProductData } from '@legacy/common-ui-models';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { createFunnelEffectCreators } from '@innogy/feh/shared';

import {
  handleHeatpumpsFunnelGenericErrorAction,
  handleHeatpumpsFunnelPrivateErrorAction,
  initializeHeatpumpsFunnelStepAction,
  mintHeatpumpsTrackingIdAction,
  onHeatpumpsFunnelNavigationAction,
  setHeatpumpsFunnelInitializedAction,
} from './heatpumps-funnel.actions';
import { selectHeatpumpsFunnelSettings } from './heatpumps-funnel.selectors';

@Injectable()
export class HeatpumpsFunnelEffects {
  funnelSettings$ = this.store$.select(selectHeatpumpsFunnelSettings);

  constructor(
    private readonly actions$: Actions,
    private readonly store$: Store,
    private readonly jss: JssPlatformService,
    private readonly analyticsUtils: AnalyticsUtils
  ) {}

  private readonly effects = createFunnelEffectCreators<
    HeatpumpsFunnelStep,
    HeatpumpsFunnelSettingsInterface,
    GenericProductData
  >(
    this.actions$,
    this.funnelSettings$,
    of(this.jss.isEditorActive()),
    'startPage',
    'wizard',
    this.analyticsUtils,
    {
      initializeFunnelStepAction: initializeHeatpumpsFunnelStepAction,
      handleFunnelPrivateErrorAction: handleHeatpumpsFunnelPrivateErrorAction,
      onFunnelNavigationAction: onHeatpumpsFunnelNavigationAction,
      setFunnelInitializedAction: setHeatpumpsFunnelInitializedAction,
      handleFunnelGenericErrorAction: handleHeatpumpsFunnelGenericErrorAction,
      mintTrackingIdAction: mintHeatpumpsTrackingIdAction,
    }
  );

  public readonly onInitHeatpumpsFunnel$ =
    this.effects.initializeFunnelStepEffectCreator();

  public readonly mintHeatpumpsFunnelTrackingId$ =
    this.effects.mintTrackingIdEffectCreator();

  public readonly onHeatpumpsFunnelGenericError$ =
    this.effects.handleFunnelGenericErrorEffectCreator();

  public readonly onHeatpumpsFunnelNavigation$ =
    this.effects.onFunnelNavigationEffectCreator();

  public readonly onHeatpumpsFunnelPrivateError$ =
    this.effects.handleFunnelPrivateErrorEffectCreator();
}
